// /**
//  * Create Grouping Product
//  */

// React
import React, {useEffect, useState} from 'react';

// UI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  Button,
  Grid,
  Card,
  Typography,
  SvgIcon,
  ClickAwayListener,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';

import List from './components/errorList';
import {UploadProductsRequestBuilder, UploadUpdateProductsRequestBuilder} from 'client-sdk/src/products/products';
import Client from 'client-sdk/src/client';
import handleNotfication from '../../utils/handleNotfication';
import handleError from '../../utils/handleError';
import Modal from '../../components/Modal';
import windowSize from '../../utils/hook/useWindowResize';
import OptionsModal from './components/optionsModal';
import TPSRepository from 'client-sdk/src/Repository/tps-management-repository';
import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';
import {Tps} from './interfaces';
import {
  dsiDownload,
  dsiUpload,
  dsiEdit,
  dsiRefresh,
} from '../../components/icons/customIcons';
import SelectCard from './components/selectCard';
import RonadIcons from '../../components/iconComponent';
import disableElement from '../../utils/disableElement';
import { useHistory } from 'react-router';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  history: any;
};

interface Errors {
  code: number;
  text: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '& MuiCardContent-root': {
      padding: '0px',
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    type: {
      flexGrow: 1,
      maxWidth: 500,
    },
    paper: {
      marginTop: '36px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      // marginBottom: '14px',
      overflow: 'visible',
      // padding: '14px',
      paddingBottom: '0',
    },

    cardContent: {
      // paddingLeft: '14px',
    },

    labelInput: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      // padding: '15px',
      // marginTop: '16px',
      borderRadius: '5px',
      border: 'solid 1px #949494',
      borderStyle: 'solid',
      width: '100%',
      minHeight: '139px',
    },
    cardContentOrder: {
      paddingBottom: '10px',
    },
    //Aryan
    inputLink: {
      display: 'flex',
      flex: 1,
      flexGrow: 0,
      alignItmes: 'center',
      justifyContent: 'space-between',
    },
    uploadInput: {
      cursor: 'pointer',
      alignSelf: 'center',
      position: 'absolute',
      top: '0',
      right: '0',
      width: '100%',
      height: '100%',
      opacity: '0',
    },
    labelUpperText: {
      fontSize: '16px',
      fontWeight: 700,
    },
    labelLink: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px',
      textDecorationLine: 'underline',
      textDecorationStyle: 'solid',
      color: '#0375E8',
      // borderBottom: 'solid 1px #0375E8',
    },
    infoTooltip: {
      color: '#217AFF',
      position: 'absolute',
      top: 0,
      right: 0,
    },
    tooltip: {
      fontSize: '14px',
    },
    syncHistory: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'center',
    },
    syncHistoryRow: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      justifyContent: 'space-between',
    },
  })
);
const token = localStorage.getItem('token') || '';
const profile = localStorage.getItem('profile') || []

function GroupingAddProduct(props: Props) {
  const classes = useStyles();
  const history = useHistory()

  const EXCEL_TOOLTIP_MESSAGE =
    'در این قسمت می‌توانید با بارگذاری فایل اکسل، لیست کالاهای خود را به یک باره وارد نمایید (فایل راهنما مطالعه شود)';
  const INVENTORY_TOOLTIP_MESSAGE =
    'در این قسمت می‌توانید با بارگذاری فایل اکسل، موجودی کالاهای خود را ویرایش نمایید (فایل راهنما مطالعه شود)';
  const EXTERNAL_CODE_TOOLTIP_MESSAGE =
    'در این قسمت می‌توانید کد کالای رونادی و دیگر کد های یکپارچگی کالاهای خود را وارد به صورت گروهی تغییر دهید (فایل راهنما مطالعه شود)';
  /* const SYNC_TOOLTIP_MESSAGE = 'با انتخاب این گزینه شما می‌توانید اقدام به همگام سازی کالاهای خود را با سایر پلتفرم ها نمایید'; */
  const SYNC_TOOLTIP_MESSAGE =
    'با انتخاب این گزینه شما می‌توانید کالاهای خود را با سایر پلتفرم ها همگام‌سازی نمایید';
  const [chosenOption, setChosenOption] = useState<string | undefined>(
    undefined
  );
  const [file, setFile] = useState<any>(null);
  const [fileName, setFileName] = useState<any>('');
  const [errorList, setErrorList] = useState<Errors[]>([]);
  const [loading, setLoading] = useState(false as boolean);
  const [isMob, setIsMob] = useState(false);
  const {width} = windowSize();
  const [syncOptionsModalOpen, setSyncOptionsModalOpen] = useState<boolean>(false);
  const [activeCardId, setActiveCardId] = useState<number>(0);

  const handleCardClick = id => {
    setActiveCardId(id);
  };

  const handleFileDelegation = (id: number, file: any) => {
    setActiveCardId(id);
    setFile(file);
  }

  const handleOptionChanged = async (option: string) => {
    setChosenOption(option);
    setSyncOptionsModalOpen(false);
    //REQUEST SYNC
    try {
      // fetchBasalam();
      const response = await TPSRepository.FetchBasalamProducts();
      handleSyncNotification(response.data as Tps);
      // console.log('Response back: ', response);
    } catch (error) {
      // console.log("ERROR!", error);
      handleError(error);
    }
  };

  const handleSyncNotification = (data: Tps) => {
    if (data.productDetails?.length > 0) {
      handleNotfication('همگام‌سازی با موفیت انجام شد.', 'success');
    } else {
      handleNotfication('محصول جدیدی برای همگام‌سازی وجود ندارد.', 'info');
    }
  };

  // const url = 'http://api.qa.ronad.ir/api/tps-management/products/fetch';
  const fetchBasalam = async () => {
    const url = 'http://api.qa.ronad.ir/api/tps-management/products/fetch';
    const apiKey = localStorage.getItem('token');
    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${apiKey}`,
        Cookie: 'JSESSIONID=77D46A048C8677B8FC5BB499B68B59C9',
        'Content-Type': 'application/json',
      },
    };

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      // console.log(data);
    } catch (error) {
      console.error(error);
    } finally {
      // console.log('finally shot.');
    }
  };
  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const handleSubmitForm = () => {
    if(activeCardId === 1){
      submitFile(file);
    }else if(activeCardId === 2){
      editFile(file);
    }else if(activeCardId === 3) {
      submitInventory(file)
    }else {
      handleNotfication('خطایی در بارگذاری فایل وجود دارد.', 'error');
    }
    
  };

  // @ts-ignore
  // CHANGE HERE ARYAN for edit -> update
  const submitFile = async file => {
    try {
      setLoading(true);
      let payload = new FormData();
      if(file === null || file === undefined){
        handleNotfication('لطفا فایلی را برای بارگذاری انتخاب نمائید.', 'error');
        return 0; 
      }
      else {
        
      payload.append('file', file);
      const makeRequest = new UploadProductsRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('کالا‌ها با موفقیت ایجاد شدند', 'success');
      props.history.push('/your-products');
      }
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }
      if (err?.response.status === 406) {
        // @ts-ignore
        handleNotfication(
          'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
          'error'
        );
        // @ts-ignore
        setErrorList(handleErrorList(err.response.data));
      }
      handleError(err);
    } finally {
      setFileName('');
      setFile(null);
      setLoading(false);
    }
  };

  const editFile = async file => {
    try {
      setLoading(true);
      let payload = new FormData();
      if(file === null || file === undefined){
        handleNotfication('لطفا فایلی را برای بارگذاری انتخاب نمائید.', 'error');
        return 0; 
      }
      else {
        
      payload.append('file', file);
      const makeRequest = new UploadUpdateProductsRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
        //change
      handleNotfication('کالا‌ها با موفقیت به‌روز شدند', 'success');
      props.history.push('/your-products');
      }
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }
      if (err?.response.status === 406) {
        // @ts-ignore
        handleNotfication(
          'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
          'error'
        );
        // @ts-ignore
        setErrorList(handleErrorList(err.response.data));
      }
      handleError(err);
    } finally {
      setFileName('');
      setFile(null);
      setLoading(false);
    }
  };

  const submitInventory = async (file) => {
    const partnerId = localStorage.getItem('partnerId');
    try {
      setLoading(true);
      const payload = new FormData();
      if (file) {
        payload.append('file', file[0]);
      }
      const response = await warehouseRepository.updateExcelWarehouseInventories(
        {
          payload: { body: payload, partnerId },
        }
      );
      // setData(response.data);
      handleNotfication('موجودی ها با موفقیت به روز رسانی شدند', 'success');
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }
      if (err?.response?.status === 406) {
        handleNotfication(
          'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
          'error'
        );
        setErrorList(handleErrorList(err.response.data));
      }
      handleError(err);
    } finally {
      setFileName('');
      setFile(null);
      setLoading(false);
    }
  };

  
  const handleDownloadGuide = () => {
    switch (activeCardId) {
      case 1:
        window.open('/ProductInstruction.xlsx');
        break;

      case 2:
        //logic for downloading external code guide file
        window.open('/ProductUpdateInstruction.xlsx')
        break;
      
      case 3:
        //logic for downloading external code guide file
        window.open('/InventoryInstruction.xlsx')
        break;
        
      default:
        break;
    }
    // history.push('/ProductInstruction.xlsx');
  };

  const handleDownloadSample = () => {
    switch (activeCardId) {
      case 1:
        window.open('/sampleProduct.xlsx');
        break;

      case 2:
        window.open('/ProductUpdateSample.xlsx');
        break;

      case 2:
        window.open('/sampleInventory.xlsx');
        break;
        
      default:
        break;
    }
  };

  const handleErrorList = (data: any) => {
    const errorList: Array<unknown> = [];
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        const element = data[key];
        for (let index = 0; index < element.length; index++) {
          const text = element[index];
          errorList.push({code: key, text});
        }
      }
    }

    return errorList;
  };

  return (
    <React.Fragment>
      <div
        style={{
          backgroundColor: '#FFF',
          padding: '24px',
          marginTop: "24px",
          borderRadius: "4px"
        }}
      >
        <div
          style={{
            marginBottom: '24px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            // padding: '10px',
          }}
        >
          <Typography
            style={{
              fontSize: '20px',
              fontWeight: '700',
            }}
          >
            <Button onClick={() => history.goBack()}>
              <RonadIcons name='chevronRight' />
            </Button>
            {`بارگذاری فایل`}
          </Typography>
        </div>

        <Grid
          md={12}
          style={{
            padding: '24px',
            boxShadow: '0px 3px 24px rgba(0, 0, 0, 0.06)',
          }}
        >
          <Card className={classes.card} style={{marginTop: '0'}} elevation={0}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignContent: 'center',
                justifyContent: 'end',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
                {/*ARYAN - 
                  I disabled this button because there was no guide
                  to teach editing external code at the time I wrote
                  it.
                */}
              <Button
                onClick={handleDownloadGuide}
                size="large"
                disabled={activeCardId < 1 /*|| activeCardId === 2*/}
                variant="contained"
                color="primary"
                endIcon={
                  <SvgIcon viewBox="-2 -2 20 20">
                    <path d={dsiDownload} />
                  </SvgIcon>
                }
              >
                {'دریافت فایل راهنما'}
              </Button>
              <Button
                onClick={handleDownloadSample}
                size="large"
                disabled={activeCardId < 1}
                variant="contained"
                color="primary"
                endIcon={
                  <SvgIcon viewBox="-2 -2 20 20">
                    <path d={dsiDownload} />
                  </SvgIcon>
                }
              >
                {'دریافت فایل نمونه'}
              </Button>
            </div>

            <div
              style={{
                padding: '0px',
              }}
            >
              <Grid container className={classes.cardContent}>
                <ClickAwayListener onClickAway={() => setActiveCardId(0)}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    padding: '0',
                    display: 'flex',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: 'row',
                    flex: 1,
                    width: '100%',
                    flexGrow: 1,
                    alignContent: 'space-between',
                    justifyContent: 'space-between',
                    // marginTop: '24px',
                    flexWrap: 'nowrap',
                    gap: '24px',
                    paddingTop: '24px',
                  }}
                >
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                        }}
                      >
                        <SelectCard
                          id={1}
                          iconSize={36}
                          iconPath={dsiUpload}
                          title={'بارگذاری فایل Excel  کالاها'}
                          infoMessage={EXCEL_TOOLTIP_MESSAGE}
                          onCardClick={handleCardClick}
                          cardSelected={activeCardId}
                          setSelectedFile={setFile}
                          selectedFile={file}
                          passSelectedFile={handleFileDelegation}
                        />
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                        }}
                      >
                        <SelectCard
                          id={2}
                          iconSize={36}
                          iconPath={dsiEdit}
                          title={'ویرایش کد یکپارچگی'}
                          infoMessage={EXTERNAL_CODE_TOOLTIP_MESSAGE}
                          onCardClick={handleCardClick}
                          cardSelected={activeCardId}
                          setSelectedFile={setFile}
                          selectedFile={file}
                          passSelectedFile={handleFileDelegation}
                        />
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                        }}
                      >
                        <SelectCard
                          id={3}
                          iconSize={36}
                          iconPath={dsiUpload}
                          title={'بارگذاری گروهی تنظیمات موجودی'}
                          infoMessage={INVENTORY_TOOLTIP_MESSAGE}
                          onCardClick={handleCardClick}
                          cardSelected={activeCardId}
                          setSelectedFile={setFile}
                          selectedFile={file}
                          passSelectedFile={handleFileDelegation}
                        />
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        lg={12}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                        }}
                      >
                        <SelectCard
                          id={4}
                          iconSize={36}
                          iconPath={dsiRefresh}
                          title={'همگام سازی از طریق یکپارچگی '}
                          infoMessage={SYNC_TOOLTIP_MESSAGE}
                          onCardClick={() => {
                            setSyncOptionsModalOpen(true);
                          }}
                          cardSelected={activeCardId}
                          isButton
                        />
                      </Grid>
                    </Grid>
                </Grid>
                  </ClickAwayListener>
              </Grid>
              <Grid container className='notif'>
                <RonadIcons name='information' size={0.7} style={{color: "#43778E"}}/> 
                  <Typography style={{marginRight: "10px", fontSize: "14px"}}>
                    شما می‌توانید با انتخاب گزینه‌های بالا نسبت به تعریف، ویرایش و
                    همگام‌سازی کالاهای خود اقدام نمایید. لطفا قبل از اقدام به
                    تعریف کالا، ویدیوی آموزشی را تماشا فرمایید.
                  </Typography>
              </Grid>
              <Grid container justifyContent="flex-end">
                <Grid
                  item
                  style={{
                    paddingTop: '24px',
                  }}
                >
                  {disableElement(profile) ? <Button
                    style={{
                      minWidth: '69px',
                    }}
                    type="button"
                    disabled
                    size="medium"
                    data-cy="search"
                    autoFocus
                    variant="contained"
                    color="primary"
                  >
                    ذخیره
                  </Button> : <Button
                    style={{
                      minWidth: '69px',
                    }}
                    type="submit"
                    disabled={loading}
                    size="medium"
                    data-cy="search"
                    autoFocus
                    variant="contained"
                    color="primary"
                    onClick={handleSubmitForm}
                  >
                    ذخیره
                  </Button>}
                </Grid>
              </Grid>
            </div>
          </Card>
        </Grid>
        {/*Tarikhche HamgamSaazi*/}
        {/*Disabled for now
        <div
          style={{
            marginTop: '24px',
            marginBottom: '24px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'flex-end',
            padding: '10px',
          }}
        >
          <Typography
            style={{
              fontSize: '20px',
              fontWeight: '700',
            }}
          >
            {`تاریخچه همگام‌سازی`}
          </Typography>
        </div>
        <div className={classes.syncHistory}>
          <div className={classes.syncHistoryRow}>
              
            </div>
        </div>
        */}

        {/* END of Tarikhche Hamgam Saazi*/}
        
        {/* <Grid
          md={12}
          style={{
            padding: '24px',
            boxShadow: '0px 3px 24px rgba(0, 0, 0, 0.06)',
          }}
        >
          <Card className={classes.card} style={{marginTop: '0'}} elevation={0}>
            <CardContent
              className={classes.cardContentOrder}
              style={{
                padding: '0px',
              }}
            ></CardContent>
          </Card>
        </Grid> */}

        {errorList?.length > 0 && <List data={errorList} />}

       
      </div>
      <Modal
        maxWidth="lg"
        onClose={() => setSyncOptionsModalOpen(false)}
        open={syncOptionsModalOpen}
        content={
          <React.Fragment>
            <OptionsModal changeOptionState={handleOptionChanged} />
          </React.Fragment>
        }
      />
    </React.Fragment>
  );
}

export default GroupingAddProduct;
